
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {TradeHistoryInfoResponse} from './TradeHistoryInfoResponse';
import {RequestDirection} from '../core/RequestDirection';
import {FieldModelRequestDirection} from '../core/RequestDirection';
import {TradeTransactionType} from '../core/TradeTransactionType';
import {FieldModelTradeTransactionType} from '../core/TradeTransactionType';
import {OrderType} from '../core/OrderType';
import {FieldModelOrderType} from '../core/OrderType';

/**
 * TradeHistoryInfoFilterRequest struct
 */
class TradeHistoryInfoFilterRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!RequestDirection=} requestDirection
   * @param {Date=} requestFrom
   * @param {Date=} requestTo
   * @param {!Set=} symbols
   * @param {!Set=} transactionTypes
   * @param {!Set=} orderTypes
   * @param {number=} lastRecordId
   * @param {!number=} pageSize
   * @param {number=} orderId
   * @param {!boolean=} latestOrderState
   * @constructor
   */
  constructor (parent = new Request(), requestDirection = new RequestDirection(RequestDirection.FORWARD), requestFrom = null, requestTo = null, symbols = new Set(), transactionTypes = new Set(), orderTypes = new Set(), lastRecordId = null, pageSize = 1000, orderId = null, latestOrderState = false) {
    super()
    super.copy(parent)
    this.RequestDirection = requestDirection
    this.RequestFrom = requestFrom
    this.RequestTo = requestTo
    this.Symbols = symbols
    this.TransactionTypes = transactionTypes
    this.OrderTypes = orderTypes
    this.LastRecordId = lastRecordId
    this.PageSize = pageSize
    this.OrderId = orderId
    this.LatestOrderState = latestOrderState
  }

  /**
   * Copy struct (shallow copy)
   * @this {!TradeHistoryInfoFilterRequest}
   * @param {!TradeHistoryInfoFilterRequest} other Other struct
   * @returns {!TradeHistoryInfoFilterRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.RequestDirection != null) {
      this.RequestDirection = RequestDirection.fromObject(other.RequestDirection)
    } else {
      this.RequestDirection = null
    }
    if (other.RequestFrom != null) {
      if (other.RequestFrom instanceof Date) {
        this.RequestFrom = new Date(other.RequestFrom.getTime())
      } else {
        this.RequestFrom = new Date(Math.round(other.RequestFrom / 1000000))
      }
    } else {
      this.RequestFrom = null
    }
    if (other.RequestTo != null) {
      if (other.RequestTo instanceof Date) {
        this.RequestTo = new Date(other.RequestTo.getTime())
      } else {
        this.RequestTo = new Date(Math.round(other.RequestTo / 1000000))
      }
    } else {
      this.RequestTo = null
    }
    if (other.Symbols != null) {
      this.Symbols = new Set()
      for (let item of other.Symbols) {
        if (item != null) {
          let tempItem
          tempItem = item
          this.Symbols.add(tempItem)
        } else {
          this.Symbols.add(null)
        }
      }
    } else {
      this.Symbols = null
    }
    if (other.TransactionTypes != null) {
      this.TransactionTypes = new Set()
      for (let item of other.TransactionTypes) {
        if (item != null) {
          let tempItem
          tempItem = TradeTransactionType.fromObject(item)
          this.TransactionTypes.add(tempItem)
        } else {
          this.TransactionTypes.add(null)
        }
      }
    } else {
      this.TransactionTypes = null
    }
    if (other.OrderTypes != null) {
      this.OrderTypes = new Set()
      for (let item of other.OrderTypes) {
        if (item != null) {
          let tempItem
          tempItem = OrderType.fromObject(item)
          this.OrderTypes.add(tempItem)
        } else {
          this.OrderTypes.add(null)
        }
      }
    } else {
      this.OrderTypes = null
    }
    if (other.LastRecordId != null) {
      this.LastRecordId = UInt64.fromNumber(other.LastRecordId)
    } else {
      this.LastRecordId = null
    }
    if (other.PageSize != null) {
      this.PageSize = other.PageSize
    } else {
      this.PageSize = null
    }
    if (other.OrderId != null) {
      this.OrderId = UInt64.fromNumber(other.OrderId)
    } else {
      this.OrderId = null
    }
    if (other.LatestOrderState != null) {
      this.LatestOrderState = other.LatestOrderState
    } else {
      this.LatestOrderState = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!TradeHistoryInfoFilterRequest}
   * @returns {!TradeHistoryInfoFilterRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new TradeHistoryInfoFilterRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new TradeHistoryInfoFilterRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!TradeHistoryInfoFilterRequest}
   * @param {!TradeHistoryInfoFilterRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof TradeHistoryInfoFilterRequest)) {
      throw new TypeError('Instance of TradeHistoryInfoFilterRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!TradeHistoryInfoFilterRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      RequestDirection: ((this.RequestDirection != null) ? this.RequestDirection : null),
      RequestFrom: ((this.RequestFrom != null) ? (this.RequestFrom.getTime() * 1000000) : null),
      RequestTo: ((this.RequestTo != null) ? (this.RequestTo.getTime() * 1000000) : null),
      Symbols: ((this.Symbols != null) ? Array.from(this.Symbols, item => ((item != null) ? item : null)) : null),
      TransactionTypes: ((this.TransactionTypes != null) ? Array.from(this.TransactionTypes, item => ((item != null) ? item : null)) : null),
      OrderTypes: ((this.OrderTypes != null) ? Array.from(this.OrderTypes, item => ((item != null) ? item : null)) : null),
      LastRecordId: ((this.LastRecordId != null) ? this.LastRecordId.toNumber() : null),
      PageSize: ((this.PageSize != null) ? this.PageSize : null),
      OrderId: ((this.OrderId != null) ? this.OrderId.toNumber() : null),
      LatestOrderState: ((this.LatestOrderState != null) ? this.LatestOrderState : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return TradeHistoryInfoFilterRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!TradeHistoryInfoFilterRequest} other Object value
   * @returns {!TradeHistoryInfoFilterRequest} Created struct
   */
  static fromObject (other) {
    return new TradeHistoryInfoFilterRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!TradeHistoryInfoFilterRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return TradeHistoryInfoFilterRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!TradeHistoryInfoFilterRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 5120
  }
}

export { TradeHistoryInfoFilterRequest };

/**
 * Fast Binary Encoding TradeHistoryInfoFilterRequest field model
 */
class FieldModelTradeHistoryInfoFilterRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.RequestDirection = new FieldModelRequestDirection(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.RequestFrom = new fbe.FieldModelOptional(new fbe.FieldModelTimestamp(buffer, this.RequestDirection.fbeOffset + this.RequestDirection.fbeSize), buffer, this.RequestDirection.fbeOffset + this.RequestDirection.fbeSize)
    this.RequestTo = new fbe.FieldModelOptional(new fbe.FieldModelTimestamp(buffer, this.RequestFrom.fbeOffset + this.RequestFrom.fbeSize), buffer, this.RequestFrom.fbeOffset + this.RequestFrom.fbeSize)
    this.Symbols = new fbe.FieldModelSet(new fbe.FieldModelString(buffer, this.RequestTo.fbeOffset + this.RequestTo.fbeSize), buffer, this.RequestTo.fbeOffset + this.RequestTo.fbeSize)
    this.TransactionTypes = new fbe.FieldModelSet(new FieldModelTradeTransactionType(buffer, this.Symbols.fbeOffset + this.Symbols.fbeSize), buffer, this.Symbols.fbeOffset + this.Symbols.fbeSize)
    this.OrderTypes = new fbe.FieldModelSet(new FieldModelOrderType(buffer, this.TransactionTypes.fbeOffset + this.TransactionTypes.fbeSize), buffer, this.TransactionTypes.fbeOffset + this.TransactionTypes.fbeSize)
    this.LastRecordId = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.OrderTypes.fbeOffset + this.OrderTypes.fbeSize), buffer, this.OrderTypes.fbeOffset + this.OrderTypes.fbeSize)
    this.PageSize = new fbe.FieldModelUInt32(buffer, this.LastRecordId.fbeOffset + this.LastRecordId.fbeSize)
    this.OrderId = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.PageSize.fbeOffset + this.PageSize.fbeSize), buffer, this.PageSize.fbeOffset + this.PageSize.fbeSize)
    this.LatestOrderState = new fbe.FieldModelBool(buffer, this.OrderId.fbeOffset + this.OrderId.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelTradeHistoryInfoFilterRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelTradeHistoryInfoFilterRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelTradeHistoryInfoFilterRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.RequestDirection.fbeSize + this.RequestFrom.fbeSize + this.RequestTo.fbeSize + this.Symbols.fbeSize + this.TransactionTypes.fbeSize + this.OrderTypes.fbeSize + this.LastRecordId.fbeSize + this.PageSize.fbeSize + this.OrderId.fbeSize + this.LatestOrderState.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelTradeHistoryInfoFilterRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.RequestDirection.fbeExtra + this.RequestFrom.fbeExtra + this.RequestTo.fbeExtra + this.Symbols.fbeExtra + this.TransactionTypes.fbeExtra + this.OrderTypes.fbeExtra + this.LastRecordId.fbeExtra + this.PageSize.fbeExtra + this.OrderId.fbeExtra + this.LatestOrderState.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelTradeHistoryInfoFilterRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelTradeHistoryInfoFilterRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelTradeHistoryInfoFilterRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 5120
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelTradeHistoryInfoFilterRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelTradeHistoryInfoFilterRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.RequestDirection.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.RequestDirection.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RequestDirection.fbeSize

    if ((fbeCurrentSize + this.RequestFrom.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.RequestFrom.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RequestFrom.fbeSize

    if ((fbeCurrentSize + this.RequestTo.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.RequestTo.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RequestTo.fbeSize

    if ((fbeCurrentSize + this.Symbols.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Symbols.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Symbols.fbeSize

    if ((fbeCurrentSize + this.TransactionTypes.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TransactionTypes.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionTypes.fbeSize

    if ((fbeCurrentSize + this.OrderTypes.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderTypes.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderTypes.fbeSize

    if ((fbeCurrentSize + this.LastRecordId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.LastRecordId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LastRecordId.fbeSize

    if ((fbeCurrentSize + this.PageSize.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.PageSize.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PageSize.fbeSize

    if ((fbeCurrentSize + this.OrderId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderId.fbeSize

    if ((fbeCurrentSize + this.LatestOrderState.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.LatestOrderState.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LatestOrderState.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelTradeHistoryInfoFilterRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelTradeHistoryInfoFilterRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelTradeHistoryInfoFilterRequest}
   * @param {!TradeHistoryInfoFilterRequest} fbeValue Default value, defaults is new TradeHistoryInfoFilterRequest()
   * @returns {!TradeHistoryInfoFilterRequest} TradeHistoryInfoFilterRequest value
   */
  get (fbeValue = new TradeHistoryInfoFilterRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelTradeHistoryInfoFilterRequest}
   * @param {!TradeHistoryInfoFilterRequest} fbeValue TradeHistoryInfoFilterRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.RequestDirection.fbeSize) <= fbeStructSize) {
      fbeValue.RequestDirection = this.RequestDirection.get(new RequestDirection(RequestDirection.FORWARD))
    } else {
      fbeValue.RequestDirection = new RequestDirection(RequestDirection.FORWARD)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RequestDirection.fbeSize

    if ((fbeCurrentSize + this.RequestFrom.fbeSize) <= fbeStructSize) {
      fbeValue.RequestFrom = this.RequestFrom.get()
    } else {
      fbeValue.RequestFrom = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RequestFrom.fbeSize

    if ((fbeCurrentSize + this.RequestTo.fbeSize) <= fbeStructSize) {
      fbeValue.RequestTo = this.RequestTo.get()
    } else {
      fbeValue.RequestTo = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RequestTo.fbeSize

    if ((fbeCurrentSize + this.Symbols.fbeSize) <= fbeStructSize) {
      this.Symbols.get(fbeValue.Symbols)
    } else {
      fbeValue.Symbols.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Symbols.fbeSize

    if ((fbeCurrentSize + this.TransactionTypes.fbeSize) <= fbeStructSize) {
      this.TransactionTypes.get(fbeValue.TransactionTypes)
    } else {
      fbeValue.TransactionTypes.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionTypes.fbeSize

    if ((fbeCurrentSize + this.OrderTypes.fbeSize) <= fbeStructSize) {
      this.OrderTypes.get(fbeValue.OrderTypes)
    } else {
      fbeValue.OrderTypes.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderTypes.fbeSize

    if ((fbeCurrentSize + this.LastRecordId.fbeSize) <= fbeStructSize) {
      fbeValue.LastRecordId = this.LastRecordId.get()
    } else {
      fbeValue.LastRecordId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LastRecordId.fbeSize

    if ((fbeCurrentSize + this.PageSize.fbeSize) <= fbeStructSize) {
      fbeValue.PageSize = this.PageSize.get(1000)
    } else {
      fbeValue.PageSize = 1000
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PageSize.fbeSize

    if ((fbeCurrentSize + this.OrderId.fbeSize) <= fbeStructSize) {
      fbeValue.OrderId = this.OrderId.get()
    } else {
      fbeValue.OrderId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderId.fbeSize

    if ((fbeCurrentSize + this.LatestOrderState.fbeSize) <= fbeStructSize) {
      fbeValue.LatestOrderState = this.LatestOrderState.get(false)
    } else {
      fbeValue.LatestOrderState = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LatestOrderState.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelTradeHistoryInfoFilterRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelTradeHistoryInfoFilterRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelTradeHistoryInfoFilterRequest}
   * @param {!TradeHistoryInfoFilterRequest} fbeValue TradeHistoryInfoFilterRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelTradeHistoryInfoFilterRequest}
   * @param {TradeHistoryInfoFilterRequest} fbeValue TradeHistoryInfoFilterRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.RequestDirection.set(fbeValue.RequestDirection)
    this.RequestFrom.set(fbeValue.RequestFrom)
    this.RequestTo.set(fbeValue.RequestTo)
    this.Symbols.set(fbeValue.Symbols)
    this.TransactionTypes.set(fbeValue.TransactionTypes)
    this.OrderTypes.set(fbeValue.OrderTypes)
    this.LastRecordId.set(fbeValue.LastRecordId)
    this.PageSize.set(fbeValue.PageSize)
    this.OrderId.set(fbeValue.OrderId)
    this.LatestOrderState.set(fbeValue.LatestOrderState)
  }
}

export { FieldModelTradeHistoryInfoFilterRequest };

/**
 * Fast Binary Encoding TradeHistoryInfoFilterRequest model
 */
class TradeHistoryInfoFilterRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelTradeHistoryInfoFilterRequest(this.buffer, 4)
  }

  /**
   * Get the TradeHistoryInfoFilterRequest model
   * @this {!TradeHistoryInfoFilterRequestModel}
   * @returns {!FieldModelTradeHistoryInfoFilterRequest} model TradeHistoryInfoFilterRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!TradeHistoryInfoFilterRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!TradeHistoryInfoFilterRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return TradeHistoryInfoFilterRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!TradeHistoryInfoFilterRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelTradeHistoryInfoFilterRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!TradeHistoryInfoFilterRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!TradeHistoryInfoFilterRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!TradeHistoryInfoFilterRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!TradeHistoryInfoFilterRequestModel}
   * @param {!TradeHistoryInfoFilterRequest} value TradeHistoryInfoFilterRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!TradeHistoryInfoFilterRequestModel}
   * @param {!TradeHistoryInfoFilterRequest} value TradeHistoryInfoFilterRequest value, defaults is new TradeHistoryInfoFilterRequest()
   * @return {!object} Deserialized TradeHistoryInfoFilterRequest value and its size
   */
  deserialize (value = new TradeHistoryInfoFilterRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new TradeHistoryInfoFilterRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new TradeHistoryInfoFilterRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!TradeHistoryInfoFilterRequestModel}
   * @param {!number} prev Previous TradeHistoryInfoFilterRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { TradeHistoryInfoFilterRequestModel };
TradeHistoryInfoFilterRequest.__has_response = true;
TradeHistoryInfoFilterRequest.__response_class = TradeHistoryInfoResponse;
